"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.4}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="relative w-full overflow-hidden min-h-[500px] md:min-h-[600px] lg:min-h-[700px]">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/uae_financial_market_skyline.png)] will-change-transform" style={{
      height: "120vh",
      top: "-10vh"
    }} />

      {}
      <div className="absolute inset-0 bg-secondary/60" />

      {}
      <div ref={ref} className="relative z-10 flex h-full flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center py-16 md:py-20">
        <h1 className={`mb-4 md:mb-6 max-w-3xl font-display font-bold text-white transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] text-3xl md:text-4xl lg:text-5xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Trusted Auditing Excellence in Dubai
        </h1>

        <p className={`mb-6 md:mb-8 max-w-2xl text-base md:text-lg lg:text-xl text-white/90 transition-all delay-75 duration-[var(--duration-slow)] ease-[var(--ease-smooth)] px-4 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>For over two decades, Salem Ballama Auditing of Accounts has been the trusted financial partner for local and international businesses navigating of the UAE and Middle East. We deliver more than just compliance; we deliver clarity, confidence, and a blueprint for strategic growth, backed by unparalleled judicial and regulatory experience.</p>

        <div className={`transition-all delay-150 duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <Button asChild size="lg" className="bg-primary text-foreground hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0 transition-all duration-150">
            <Link to="/BookConsultationPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 text-foreground transition-all duration-150 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 transition-all duration-150 !text-[hsl(0,0%,100%)] !bg-[hsl(22,78%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0">Book a Consultation</Link>
          </Button>
        </div>
      </div>
    </section>;
}